import { createReducer } from '../helpers';

import { DraftToolbarActionTypes } from '../actions/types';

const initialState = {
  isExpandView: false,
};

const draftToolbarReducer = createReducer(
  initialState,
  {
    [DraftToolbarActionTypes.expandView]: state => ({ ...state, isExpandView: true }),
    [DraftToolbarActionTypes.normalView]: state => ({ ...state, isExpandView: false }),
  },
);

export default draftToolbarReducer;
